var 
    _window,
    _html,
    _body
;

var modal_FN = function(){
    modal = this;
    modal.init();
};

(function($){

    modal_FN.prototype = {

        lastScrollTop : 0,
        
        init: function(){

            _body = $( 'body' );
            _html = $( 'html' );
            _window = $( window );

            // Is admin page
            const isAdmin = _body.hasClass( 'wp-admin' );
            if( isAdmin ) return true;

            // Bind buttons
            modal.bindButtons();

        },

        // Bind buttons
        bindButtons : function(){

            _body.on( 'click', '[data-action="open-in-modal"]', function( e ){
                e.preventDefault();
                modal.bindClick( this );
            });

        },

        bindClick : function( button ){

            button.$ = button.$ || $( button );

            // Data
            let data = button.$.data( 'modal' );
            if( data === undefined ){

                data = {
                    _ : button,
                    $ : button.$,
                    targetSelector : button.$.data( 'modal-target' ),
                    timeOpen : false,
                };

                if( data.targetSelector === undefined ){
                    console.log( 'Modal: Target selector não informado' );
                    return true;
                }

                data.$target = $( data.targetSelector );
                if( !data.$target.length ){
                    console.log( 'Modal: Target não existe' );
                    return true;
                }

                // Create modal
                data.modal = { $ : $( '<div class="modal"></div>' ).appendTo( _body ) };
                data.modal.$inner = $( '<div class="inner"></div>' ).appendTo( data.modal.$ );
                data.modal.$scroller = $( '<div class="scroller"></div>' ).appendTo( data.modal.$inner );
                data.modal.$close = $( '<button class="close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.88001 7.99996L15.6133 2.27996C15.8644 2.02889 16.0055 1.68836 16.0055 1.3333C16.0055 0.978227 15.8644 0.637701 15.6133 0.386629C15.3623 0.135557 15.0217 -0.00549316 14.6667 -0.00549316C14.3116 -0.00549316 13.9711 0.135557 13.72 0.386629L8.00001 6.11996L2.28001 0.386629C2.02894 0.135557 1.68841 -0.00549317 1.33334 -0.00549316C0.978275 -0.00549316 0.637748 0.135557 0.386677 0.386629C0.135605 0.637701 -0.00544548 0.978227 -0.00544548 1.3333C-0.00544548 1.68836 0.135605 2.02889 0.386677 2.27996L6.12001 7.99996L0.386677 13.72C0.261706 13.8439 0.162513 13.9914 0.0948219 14.1539C0.0271304 14.3163 -0.00772095 14.4906 -0.00772095 14.6666C-0.00772095 14.8426 0.0271304 15.0169 0.0948219 15.1794C0.162513 15.3419 0.261706 15.4893 0.386677 15.6133C0.510627 15.7383 0.658095 15.8375 0.820574 15.9052C0.983053 15.9728 1.15733 16.0077 1.33334 16.0077C1.50936 16.0077 1.68363 15.9728 1.84611 15.9052C2.00859 15.8375 2.15606 15.7383 2.28001 15.6133L8.00001 9.87996L13.72 15.6133C13.844 15.7383 13.9914 15.8375 14.1539 15.9052C14.3164 15.9728 14.4907 16.0077 14.6667 16.0077C14.8427 16.0077 15.017 15.9728 15.1794 15.9052C15.3419 15.8375 15.4894 15.7383 15.6133 15.6133C15.7383 15.4893 15.8375 15.3419 15.9052 15.1794C15.9729 15.0169 16.0077 14.8426 16.0077 14.6666C16.0077 14.4906 15.9729 14.3163 15.9052 14.1539C15.8375 13.9914 15.7383 13.8439 15.6133 13.72L9.88001 7.99996Z" fill="#606F7D"/></svg></button>' ).appendTo( data.modal.$inner );
                data.modal.$content = $( '<div class="content"></div>' ).appendTo( data.modal.$scroller );

                // Insert content to modal
                data.$target.appendTo( data.modal.$content ).show();

                // Bind close
                data.modal.$close.on( 'click', function(){
                    modal.close( data );
                });
                
            }

            if( data.timeOpen ) clearTimeout( data.timeOpen );
            data.timeOpen = setTimeout(function(){
                modal.open( data );
            }, 10 );

        },

        open : function( data ){

            // Lock scroll
            modal.lastScrollTop = window.pageYOffset !== undefined ? window.pageYOffset : window.scrollTop;
            window.addEventListener( 'scroll', modal.fixScrolltop );

            // Insert classes
            data.modal.$.addClass( 'opened' );
            _html.addClass( 'hide-scroll' );
            _body.addClass( 'hide-scroll' );
        
        },

        close : function( data ){

            // Unlock scroll
            window.removeEventListener( 'scroll', modal.fixScrolltop );
            
            // Remove classes
            data.modal.$.removeClass( 'opened' );
            _html.removeClass( 'hide-scroll' );
            _body.removeClass( 'hide-scroll' );
        
        },

        fixScrolltop : function( event ){

            event.preventDefault();
            window.scrollTo( 0, modal.lastScrollTop );

        }

    };

    $(function () {
        modal = new modal_FN();
    });
  
})(jQuery);
